// src/pages/Authentication/ChangePassword/PasswordRequirements.tsx
// Static component showing password requirements

import React from 'react';
import { createScreenText } from 'helpers/screenText';
const st = createScreenText('authentication');

const PasswordRequirements: React.FC = () => {
  return (
    <div
      className="alert mb-0 mt-3"
      style={{
        backgroundColor: '#f0f7ff',
        border: '1px solid #cce5ff',
        borderRadius: '8px',
      }}
    >
      <p className="mb-2 fw-semibold text-primary" style={{ fontSize: '13px' }}>
        <i className="ri-information-line me-1"></i>
        {st('yeu_cau_mat_khau_text')}
      </p>
      <ul className="mb-0 ps-3 text-muted" style={{ fontSize: '12px' }}>
        <li>{st('toi_thieu_8_ky_tu_text')}</li>
        <li>{st('co_it_nhat_1_chu_hoa_text')}</li>
        <li>{st('co_it_nhat_1_chu_so_text')}</li>
        <li>{st('co_it_nhat_1_ky_tu_text')}</li>
      </ul>
    </div>
  );
};

export default PasswordRequirements;